const routes = {
  root: '/apro/details',
}

export default routes
